<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <template v-if="verTema">
      <v-row>
        <v-col cols="12">
          <ButtonComp @click="$emit('close')" classColor="red" textButton="Volver" iconBut="fas fa-arrow-alt-circle-left"
            normalButton />
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col>
              <textfieldComp :value="listUnidad.desc_nivel" textLabel="Nivel" readonly />
            </v-col>
            <v-col>
              <textfieldComp :value="listUnidad.desc_grado" textLabel="Grado" readonly />
            </v-col>
            <v-col>
              <textfieldComp :value="listUnidad.desc_area" textLabel="Area" readonly />
            </v-col>
            <v-col>
              <textfieldComp :value="listUnidad.desc_curso" textLabel="Curso" readonly />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row dense>
            <v-col cols="12" class="d-flex  justify-end">
              <ButtonComp @click="modalFormClase(null, 'agregar', null)" textButton="Crear tema" iconBut="fas fa-plus"
                normalButton />
            </v-col>
            <v-col cosl="12" class="d-flex  justify-end">
              <ButtonComp textButton="Importar" @click="eventImportar(parametros)" iconBut="fas fa-upload"
                classColor="success" normalButton />
            </v-col>
          </v-row>
        </v-col>

        <!-- empieza la tabla -->

        <v-col cols="12">
          <ComundataTablecomp :headers="GestionContenidoVisorTemasHeaders" :items="clases">
            <template v-slot>
              <v-chip color="primary" label>
                UNIDAD: {{ listUnidad.nombre_tema }}
              </v-chip>
            </template>
            <template v-slot:edit="{ item, index }">
              <ButtonComp @click="modalFormClase(item, 'editar', index)" tooltipText="Editar tema" editButton />
            </template>

            <template v-slot:view="{ item }">
              <ButtonComp @click="VisorDiapositivas(item)" tooltipText="Ver diapositivas" verButton />
            </template>

            <template v-slot:view_diapo="{ item }">
              <ButtonComp @click="VerGCDiapositiva(item)" iconBut="fas fa-file-signature"
                tooltip-text="Crear diapositivas" class-color="orange" />
            </template>

            <template v-slot:view_somos_habiles="{ item }">
              <ButtonComp @click="ViewSomosHabiles(item)" addButton tooltipText="Crear preguntas" />
            </template>

            <!-- cuaderno de trabajo -->
            <!-- <template v-slot:cuaderno="{ item }">
              <ButtonComp v-if="item.cuaderno_trabajo === '' || item.cuaderno_trabajo === null" @click="AddCuaderno(item)"
                uploadButton tooltipText="Subir cuaderno de actividades" />


              <v-menu v-else offset-y>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <ButtonComp icon-but="fas fa-book-reader" class-color="primary"
                      tooltip-text="Opciones cuaderno de actividades" />
                  </div>
                </template>
                <v-list class="d-flex justify-center">
                  <v-list-item>
                    <ButtonComp :href="URL_SPACE + '/' + item.cuaderno_trabajo" icon-but="fas fa-file-word"
                      tooltipText="Descargar cuaderno de actividades" class-color="primary" />
                  </v-list-item>
                  <v-list-item>
                    <ButtonComp @click="eventDeleteCuaderno(item)" tooltipText="Eliminar cuaderno de actividades"
                      delete-button />
                  </v-list-item>
                </v-list>
              </v-menu>
            </template> -->


            <!-- new versión -->
            <template v-slot:cuaderno="{ item }">

              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <ButtonComp tooltip-text="Opciones cuaderno de actividades" class-color="primary"
                      icon-but="fas fa-book-reader" />
                  </div>
                </template>

                <v-list dense>
                  <!-- Docente Section -->
                   <v-list-item-group>
                    <!-- titulo item -->
                    <v-list>
                      <v-list-item-content class="text-center">
                        <v-list-item-title>Docente</v-list-item-title>
                      </v-list-item-content>
                    </v-list>
                    <!-- en caso haya un cuaderno del docente -->
                    <v-list class="d-flex justify-center" v-if="item.cuaderno_trabajo_docente">
                      <v-list-item>
                        <ButtonComp @click="Download(URL_SPACE + '/' + item.cuaderno_trabajo_docente)" icon-but="fas fa-file-word"
                        tooltipText="Descargar cuaderno de actividades del docente" classColor="primary" />
                      </v-list-item>
                      <v-list-item>
                        <ButtonComp @click="eventDeleteCuaderno(item, 'cuaderno_trabajo_docente')" deleteButton
                          tooltipText="Eliminar cuaderno de actividades del docente" />
                      </v-list-item>
                    </v-list>
                    <!-- en caso no haya contenido -->
                    <v-list v-else-if="item.cuaderno_trabajo_docente === '' || item.cuaderno_trabajo_docente === null" class="d-flex justify-center">
                      <ButtonComp @click="AddCuaderno(item, 'cuaderno_trabajo_docente')" upload-button
                        tooltip-text="Subir cuaderno de actividades del docente" />
                    </v-list>
                   </v-list-item-group>
                   <!-- Estudiante Section -->
                    <v-list-item-group>
                     <v-list>
                       <v-list-item-content class="text-center my-5">
                         <v-list-item-title>Estudiante</v-list-item-title>
                       </v-list-item-content>
                     </v-list>
                     <!-- en caso haya un archivo -->
                     <v-list class="d-flex justify-center" v-if="item.cuaderno_trabajo">
                       <v-list-item>
                         <ButtonComp @click="Download(URL_SPACE + '/' + item.cuaderno_trabajo)" icon-but="fas fa-file-word"
                           tooltipText="Descargar cuaderno de actividades del estudiante" classColor="primary" />
                       </v-list-item>
                       <v-list-item>
                         <ButtonComp @click="eventDeleteCuaderno(item, 'cuaderno_trabajo')" deleteButton
                           tooltipText="Eliminar cuaderno de actividades del estudiante" />
                       </v-list-item>
                     </v-list>
                     <!-- en caso no haya un archivo -->
                     <v-list v-else class="d-flex justify-center">
                       <ButtonComp @click="AddCuaderno(item, 'cuaderno_trabajo')" upload-button
                         tooltip-text="Subir cuaderno de actividades del estudiante" />
                     </v-list>
                    </v-list-item-group>
                </v-list>

                
              </v-menu>
            </template>

            <template v-slot:session_a="{ item }">

              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <ButtonComp class-color="teal" icon-but="fas fa-file" tooltip-text="Sesión de aprendizaje" />
                  </div>
                </template>
                <v-list>
                  <v-list-item class="justify-center" v-if="item.id_sa == null || item.id_sa == ''">
                    <ButtonComp @click="ViewSessionAprendizaje('add', item)" icon-but="fas fa-plus-circle"
                      tooltip-text="Crear sesión de aprendizaje" class-color="primary" />
                  </v-list-item>
                  <v-list-item v-else class="justify-center">
                    <ButtonComp @click="ViewSessionAprendizaje('edit', item)" editButton
                      tooltip-text="Editar sesión de aprendizaje" />
                  </v-list-item>
                </v-list>

              </v-menu>
            </template>

            <template v-slot:delete="{ item, index }">
              <ButtonComp @click="ShowConfirmDeleteClase(item, index)" tooltipText="Eliminar tema" deleteButton />
            </template>
          </ComundataTablecomp>

        </v-col>

      </v-row>
    </template>






    <v-form ref="formClases" v-model="validFormClases" lazy-validation>
      <ComunDialogComp v-model="modaCrearTema" maxWidth="500" :title="formTitleClase" @close-modal="cerrarModalAddClase">
        <template v-slot:body>
          <v-row>
            <v-col align="center" cols="12">
              <v-chip class="primary">Unidad: {{ listUnidad.nombre_tema }}</v-chip>
            </v-col>

            <v-col cols="12" sm="6" md="12">
              <v-text-field @keyup.enter="addUpdateClase()" v-model="formClase.nombre_clase" ref="formClasesInput"
                label="Nombre del tema" :rules="validationRules.validateCampo"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="12">
              <v-text-field type="number" @keyup.enter="addUpdateClase()" label="Orden"
                :rules="validationRules.validateCampo" min="0" v-model="formClase.orden_clase"></v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer />
          <ButtonComp @click="addUpdateClase()" textButton="Guardar" iconBut="fas fa-save" normalButton />
          <ButtonComp @click="cerrarModalAddClase" textButton="Cancelar" classButton="ml-2" normalButton
            classColor="red" />
        </template>
      </ComunDialogComp>

    </v-form>

    <!-- modal cargar cuaderno de trabajo -->
    <v-dialog v-model="modal_cuaderno" persistent scrollable max-width="500px">
      <v-card>
        <v-card-title class="btn_otro">
          <span>Agregar cuaderno de actividades</span>
          <v-spacer></v-spacer>
          <v-btn fab dark x-small class="btn_style3" @click="CloseCuaderno">
            <v-icon dark>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-12 pb-8">
          <v-file-input show-size label="Seleccionar cuaderno de actividades"
            accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.csv,.txt" @change="CargarPrevia" ref="myFileInput" clearable
            dense counter prepend-icon="mdi-file" style="max-width: 400px"></v-file-input>
          <br />

          <div class="pl-1">
            <span v-if="!nombreArchivo" class="my-text text--error py-2">
              <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
              Ningún archivo seleccionado
            </span>
            <span v-else class="my-text text--success py-2">
              <v-icon color="success" small>mdi-check-circle-outline</v-icon>
              Archivo seleccionado
            </span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="subiendoCuaderno" :disabled="!existeArchivo" @click="SubmitFileCuaderno" color="primary"
            class="px-3">
            <v-icon left>fas fa-save</v-icon>
            Guardar cuaderno
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Confirm titleWindow="Eliminar tema" title="¿Está seguro de que desea eliminar este registro?"
      :active="confirmDeleteClase" @aceptar="DeleteClass" @cancelar="CerrarConfirmDeleteClase" />

    <Confirm titleWindow="Eliminar cuaderno de actividades" title="¿Está seguro de que desea eliminar este registro?"
      :active="confirmDeleteCuaderno" @aceptar="DeleteCuaderno" @cancelar="CerrarConfirmDeleteCuaderno" />

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>

    <!-- LoadMain -->
  <component
      :is="compNameImport"
      :estadoModal="estadoModalConfig"
      @close="estadoModalConfig = false"
      :parametros="parametroConfigVisor"
      @reloadComp="reloadClase"
      @updateClases="actualizarClases"
    >
    </component>

    <v-overlay style="z-index: 3000 !important" :value="guardando">
      <v-progress-circular indeterminate size="130">
        <h3>Guardando...</h3>
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import Confirm from "@/components/confirm";
//import {mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { mapMutations } from "vuex";
import VisorContenido from "@/views/Manager/GestionContenido/viewGC/visorGestorContenido";
import GCDiapositiva from "../gestionContenido/gcDiapositiva/gestorDiapositiva.vue";
import importarTema from "./componentes/importarClasesInteligenio.vue";
import SesionAprendizaje from "../sesionAprendizaje/sesionAprendizaje";
import BalotarioComp from "../creadorSomosHabiles/balotarioSomosHabilies";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import { GestionContenidoVisorTemasHeaders } from '../../../../helpers/headersTable';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import { validationRules } from '../../../../helpers/validatorHelpers';

export default {
  name: "Tema",

  // props: ["contenido", "elTema", "dataSet"],
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    VisorContenido,
    GCDiapositiva,
    Confirm,
    importarTema,
    SesionAprendizaje,
    BalotarioComp,
    ButtonComp,
    ComundataTablecomp,
    textfieldComp,
    ComunDialogComp
  },
  data() {
    return {
      verTema: true,
      formTitleClase: "",
      formIconClase: "",
      editedIndex: -1,
      rutaServe: API_URL,
      URL_SPACE: BUCKET_ORIGIN_SPACE,
   
      validFormClases: false,
      modaCrearTema: false,
      guardando: false,

      rul: {
        required: (value) => !!value || "Campo requerido",
      },

      GestionContenidoVisorTemasHeaders,
      idclase: null,
      index: null,
      formClase: {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_tema: null,
        nombre_clase: "",
        sesion_aprendizaje: "",
        ubicacion_repositorio: "",
        orden_clase: null,
        estado_clase: 1,
        id_usuario: sessionStorage.id,
      },
      confirmDeleteClase: false,
      confirmDeleteCuaderno: false,
      itemDelete: "",
      cuadernoToAlter: "",

      estadoModalConfig: false,
      parametroConfigVisor: [],

      compName: null,
      compNameImport: null,
      estadoComponente: true,
      parametroComp: [],

      arrayCuaderno: {},
      modal_cuaderno: false,
      existeArchivo: false,
      nombreArchivo: "",
      subiendoCuaderno: false,
      listUnidad: {},

      api_vistaclase: {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_tema: null,
        estado_clase: 1,
      },
    };
  },
  computed: {
    clases: {
      get() {
        return this.parametros.clases;
      },
      set(newValue) {
        this.parametros.clases = newValue;
      },
    },

    validationRules() {
      return validationRules;
    }
  },
  mounted() {
    this.LoadMain();
  },
  watch: {
    clases(info) {
      console.log(info);
    },

    estadoComp() {
      if (this.estadoComp) {
        this.verTema = true;
        this.LoadMain();
      } else {
        this.verTema = false;
      }
    },
  },
  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /**
     ___________________
    |  MÉTODO INICIAL */
    async LoadMain() {
      this.listUnidad = this.parametros.item;

      console.log('esto se va al importer',this.parametros);
      // this.GetTema();
    },
    /**
     ____________________________
    |  MÉTODO FORMULARIO CLASE */
    modalFormClase(item, action, index) {
      this.modaCrearTema = true;
      this.formClase.id_tema = this.listUnidad.id;
      this.formClase.orden_clase = this.parametros.clases.length + 1;
      switch (action) {
        case "agregar":
          setTimeout(() => {
            this.$refs.formClasesInput.focus();
          });
          this.editedIndex = 1;
          this.formTitleClase = "Agregar tema";
          this.formIconClase = "fas fa-plus";
          break;
        case "editar":
          setTimeout(() => {
            this.$refs.formClasesInput.$refs.input.select();
          });
          this.editedIndex = -1;
          this.formTitleClase = "Editar tema";
          this.formIconClase = "fas fa-pencil-alt";
          this.idclase = item.id;
          this.index = index;
          this.formClase.nombre_clase = item.nombre_clase;
          this.formClase.orden_clase = item.orden_clase;
          break;
      }
    },
    /**
     _______________________________
    |  MÉTODO GUARDAR O MODIFICAR */
    async addUpdateClase() {
      if (!this.$refs.formClases.validate() == true) {
        return;
      }
      let response;
      this.guardando = true;
      if (this.editedIndex == 1) {
        try {
          response = await axios.post("/administrativo/clase/", this.formClase);
          this.$emit("actualizar", this.parametros.item);
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      } else {
        try {
          response = await axios.put(
            "/administrativo/clase/" + this.idclase,
            this.formClase
          );
          this.$emit("actualizar", this.parametros.item);
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      }

      this.setEnviarMens({
        tipo: `${response.data.messageT}`,
        mensaje: `${response.data.message}`,
        tiempo: null,
      });

      this.guardando = false;
      this.cerrarModalAddClase();
    },

    async Download(url) {
      const _url = url.split("/");

      // para identificar si es una ruta
      const isOld = url.includes("undefined");

      try {
        let response;
        // si es para los cuadernos antiguos debe seguir este flujo
        if (isOld) {
          response = await axios.get(url);
        } else {
          // sino debe seguir en el space
          response = await fetch(url);
        }

        if (response) {
          // Para entender mejor esto pueden leer el archivo file.js
          const funcionDescarga = isOld ? "dowload" : "downloadFetch";
          this.$Files[funcionDescarga]({ url: url, filename: _url[_url.length - 1] });
        }
      } catch (error) {
        if (error) {
          let resp = error.response.data;
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: ` ${resp.message}`,
            tiempo: null,
          });
        }
      }
    },



    /**
     _____________________________
    |  MÉTODO CERRAR MODAL FORM */
    cerrarModalAddClase() {
      // this.btnEditar = false;
      this.$refs.formClases.resetValidation();
      this.modaCrearTema = false;
      this.limpiarCampos();
    },
    /**
     ______________________________
    |  MÉTODO LIMPIAR FORMULARIO */
    limpiarCampos() {
      this.formClase.nombre_clase = "";
    },
    /**
     __________________________
    |  MÉTODO ELIMINAR CLASE */
    async DeleteClass() {
      try {
        const response = await axios.put(
          `/administrativo/clase/dt/inac/${this.itemDelete}`
        );

        console.log("delete", response);

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });

        // this.$emit("actualizar", this.parametros.item);
        this.clases = this.clases.filter((x) => x.id != this.itemDelete);
        this.CerrarConfirmDeleteClase();
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
     ________________________________
    |  MÉTODO POPUP ELIMINAR CLASE */
    ShowConfirmDeleteClase(item, index) {
      console.log(index);
      this.confirmDeleteClase = true;
      this.index = index;
      this.itemDelete = item.id;
    },
    /**
     _________________________________________
    |  MÉTODO CERRAR MODAL CONFIRMAR DELETE */
    CerrarConfirmDeleteClase() {
      this.confirmDeleteClase = false;
      this.itemDelete = "";
      this.cuadernoToAlter = "";
    },
    /**
     _______________________________
    |  MÉTODO IMPORTAR DE MANAGER */
    eventImportar(datos) {
      console.log(datos, "datosaass");
      let params = Object.assign(datos.item, { orden: datos.clases.length + 1 });
      this.compNameImport = "importarTema";
      this.estadoModalConfig = true;
      this.parametroConfigVisor = params;      
    },
    /**
     ________________________________________
    |  MÉTODO VER COMPONENTE DE CONTENIDOS */
    async VerGCDiapositiva(item) {
      this.verTema = false;
      let data = { ...item, id_clase: item.id };
      this.parametroComp = { evento: "agregar", item: data };
      this.compName = "GCDiapositiva";
      this.estadoComponente = true;
    },
    /**
     __________________________________________
    |  MÉTODO VER COMPONENTE DE DIAPOSITIVAS */
    VisorDiapositivas(item) {
      this.parametroComp = {
        evento: "agregar",
        miniatura: false,
        id_diapositiva: 1,
        id_clase: item.id,
        tipo_contenido: "administrativo",
      };

      this.compName = "VisorContenido";
      this.estadoComponente = true;
    },
    /**
     ______________________________
    |  MÉTODO CERRAR COMPONEANTE */
    CloseModal() {
      this.estadoComponente = false;
      this.verTema = true;
      this.$emit("actualizar", this.parametros.item);
    },
    /**
     ___________________________
    |  MÉTODO CERRAR CUADERNO */
    CloseCuaderno() {
      this.modal_cuaderno = false;
      this.existeArchivo = false;
      this.arrayCuaderno = {};
      this.nombreArchivo = null; // Aquí solo necesitas poner a null el modelo
      this.cuadernoToAlter = "";
      this.$refs.myFileInput.reset();
    },
    /**
     _________________________________
    |  MÉTODO CARGA PREVIA CUADERNO */
    CargarPrevia(file) {
      this.nombreArchivo = file;
      if (this.nombreArchivo) {
        this.existeArchivo = true;
      }
    },
    /**
     ________________________________________
    |  MÉTODO ABRIR POPUP AGREGAR CUADERNO */
    AddCuaderno(item, tipoCuadernoToAdd) {
      this.modal_cuaderno = true;
      this.arrayCuaderno.id_tema = item.id_tema;
      this.arrayCuaderno.id_clase = item.id;
      this.cuadernoToAlter = tipoCuadernoToAdd;
    },
    /**
     ______________________________________________
    |  MÉTODO SUBIR CUADERNO DE TRABAJO AL SPACE */
    async SubmitFileCuaderno() {
      console.log("this.listUnidad", this.listUnidad);

      this.subiendoCuaderno = true; //animacion de loadin del btn
      let formData = new FormData();
      formData.append("subirArchivo", this.nombreArchivo);
      formData.append("id_colegio", this.listUnidad.id_colegio);
      formData.append("id_nivel", this.listUnidad.id_adm_nivel);
      formData.append("id_grado", this.listUnidad.id_grado);
      formData.append("id_area", this.listUnidad.id_adm_area);
      formData.append("id_curso", this.listUnidad.id_curso);
      formData.append("id_tema", this.arrayCuaderno.id_tema);
      formData.append("id_clase", this.arrayCuaderno.id_clase);
      formData.append("cuadernoPerfil", this.cuadernoToAlter);

      try {
        let response = await axios.post(
          "/archivo/cuadernoTrabColegioAdd",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await this.AddCuadernoTrabajo(response.data);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     _____________________________________
    |  MÉTODO SUBIR CUADERNO DE TRABAJO */
    async AddCuadernoTrabajo(response) {
      let paramCuaderno = {
        id_usuario: sessionStorage.id,
        // cuaderno_trabajo: `${response.uri}${response.nombreArchivo}`,
      };

      paramCuaderno[this.cuadernoToAlter] = `${response.uri}${response.nombreArchivo}`;

      try {
        let res = await axios.put(
          `/administrativo/clase/cuadernoTrabajo/${this.arrayCuaderno.id_clase}`,
          paramCuaderno
        );
        if (res.data.messageT == "S") {
          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Tu cuaderno de actividades fue cargado correctamente!",
            tiempo: null,
          });
          this.subiendoCuaderno = false; // termina la animacion
          this.$emit("actualizar", this.parametros.item);
        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: "Ocurrió un error al guardar su cuaderno",
            tiempo: null,
          });
        }
        setTimeout(() => {
          this.CloseCuaderno();
        }, 700);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     _________________________________________
    |  MÉTODO ABRIR MODAL ELIMINAR CUADERNO */
    eventDeleteCuaderno(item, cuadernoToDelete) {
      this.confirmDeleteCuaderno = true;
      this.itemDelete = item;
      this.cuadernoToAlter = cuadernoToDelete;
    },
    /**
     ________________________________________
    |  MÉTODO CERRAR POPUP DELETE CUADERNO */
    CerrarConfirmDeleteCuaderno() {
      this.confirmDeleteCuaderno = false;
      this.itemDelete = "";
      this.existeArchivo = false;
      this.cuadernoToAlter = "";
    },
    /**
     ______________________________
    |  MÉTODO ELIMINAR CUADERNO  */
    async DeleteCuaderno() {
      let paramCuaderno = {
        id_usuario: sessionStorage.id,
        ruta: this.itemDelete[this.cuadernoToAlter]
        // cuaderno_trabajo: null,
      };

      paramCuaderno[this.cuadernoToAlter] = null;

      // let params = {
      //   ruta: this.itemDelete.cuaderno_trabajo,
      // };

      try {
        let res = await axios.put(
          `/administrativo/clase/cuadernoTrabajo/${this.itemDelete.id}`,
          paramCuaderno
        );
        if (res.data.messageT === "S") {
          // let response = await axios.post("/archivo/delete/", params);
          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Información eliminada con éxito.!",
            tiempo: null,
          });
          this.confirmDeleteCuaderno = false;
          this.cuadernoToAlter = "";
          this.$emit("actualizar", this.parametros.item);
          this.LoadMain();
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     _____________________________________
    |  MÉTODO VER SESION DE APRENDIZAJE */
    ViewSessionAprendizaje(evento, item) {
      this.parametroComp = {
        id_clase: item.id,
        evento,
        totalTemas: this.clases.length,
        tema: item,
      };

      setTimeout(() => {
        this.compName = "SesionAprendizaje";
        this.estadoComponente = true;
      }, "500");
    },
    /**
     ________________________________________
    |  MÉTODO VER BALOTARIOS SOMOS HABILES */
    ViewSomosHabiles(item) {
      this.verTema = false;
      this.parametroComp = { evento: "view", item };
      this.compName = "BalotarioComp";
      this.estadoComponente = true;
    },

    async reloadClase(idtema){
      try {
        this.api_vistaclase.id_tema = idtema;
        const response = await axios.post(
          "/administrativo/clase/listar/",
          this.api_vistaclase
        );
        this.clases = response.data;

      } catch (error) {
        console.log(error);
      }
    },

    actualizarClases(item){
      this.clases.push(item);
    }
  },
};
</script>
